module.exports = __webpack_public_path__ + "img/11.f291ab13.jpg";